import { useContext, useEffect, useState } from "react";
import {
  changeTime,
  getAllDayEvent,
  getDateWithOffset,
  getEventId,
  getIsNightDisabled,
  getIsWeekendDisabled,
  isInactiveAllDayEvent,
  isNightEvent,
  mergeInactiveEvents,
  splitEventAtMidnight,
} from "common/Calendars/utils.ts";
import {
  NIGHT_HOURS,
  WEEK_DAYS,
  WEEKEND_DAYS,
} from "common/Calendars/constants.ts";
import { WeekDays } from "common/Calendars/types.ts";
import { OperationHoursEvent } from "@shared/types";
import { OperationHoursContext } from "features/bots/BotForm/OperationHours/OperationHours.context.ts";

const useDisableToggles = () => {
  const { myEvents, setMyEvents } = useContext(OperationHoursContext)!;

  const [isWeekendDisabled, setIsWeekendDisabled] = useState<boolean>();
  const [isNightsDisabled, setIsNightsDisabled] = useState<boolean>();

  useEffect(() => {
    if (myEvents) {
      setIsWeekendDisabled(getIsWeekendDisabled(myEvents));
      setIsNightsDisabled(getIsNightDisabled(myEvents));
    }
  }, [myEvents]);

  const toggleWeekend = () => {
    setMyEvents((prevEvents) => {
      let updatedEvents = [...(prevEvents || [])];
      if (isWeekendDisabled) {
        updatedEvents = updatedEvents.filter(
          (e) => !isInactiveAllDayEvent(e, WEEKEND_DAYS)
        );
      } else {
        WEEKEND_DAYS.map((day) => {
          updatedEvents.push(getAllDayEvent(day));
        });
      }

      setIsWeekendDisabled(!isWeekendDisabled);
      return mergeInactiveEvents(updatedEvents);
    });
  };

  const toggleNights = () => {
    setMyEvents((prevEvents) => {
      let updatedEvents: OperationHoursEvent[] = [...(prevEvents || [])];
      if (isNightsDisabled) {
        updatedEvents = updatedEvents
          .filter((event) => !isNightEvent(event))
          .map((event) => {
            let e = event;
            if (e.start && e.end && e.end.getHours() > NIGHT_HOURS[0]) {
              const end = changeTime(e.end, NIGHT_HOURS[0]);
              e = {
                ...e,
                end,
                id: getEventId(e.start, end),
              };
            }
            if (
              e.start &&
              e.end &&
              e.start.getHours() === 0 &&
              (e.end.getHours() > NIGHT_HOURS[1] ||
                (e.end.getHours() === NIGHT_HOURS[1] && e.end.getMinutes() > 0))
            ) {
              const start = changeTime(e.start, NIGHT_HOURS[1]);
              e = {
                ...e,
                start,
                id: getEventId(start, e.end),
              };
            }
            return e;
          });
      } else {
        WEEK_DAYS.forEach((day) => {
          const start = getDateWithOffset(day, NIGHT_HOURS[0]);
          const nextDay = day === WeekDays.SATURDAY ? WeekDays.SUNDAY : day + 1;
          const end = getDateWithOffset(nextDay, NIGHT_HOURS[1]);
          const nightEvent = {
            start,
            end,
            isActive: false,
          };
          const splitEvents = splitEventAtMidnight(nightEvent, start, end);
          updatedEvents = [...updatedEvents, ...splitEvents];
        });
      }

      setIsNightsDisabled(!isNightsDisabled);
      return mergeInactiveEvents(updatedEvents);
    });
  };

  return {
    isWeekendDisabled,
    isNightsDisabled,
    toggleWeekend,
    toggleNights,
  };
};

export default useDisableToggles;
